import { format } from "date-fns";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import icChecklistRounded from "../../images/ic_checklist_rounded.svg";
import icIconDetail from "../../images/ic_detail_icon.svg";
import icDownload from "../../images/ic_download.svg";
import icInfoBlack from "../../images/ic_info_black.svg";
import icInfoRed from "../../images/ic_info_red.svg";
import icPDF from "../../images/ic_pdf.svg";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { formatMoney } from "../../utils/numbers";
import AdminAskForAction from "../AdminAskForAction/AdminAskForAction";
import { ApproveButton } from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import { Quotation } from "../AdminPaymentRecaudo/AdminPaymentRecaudo.interface";
import Sidebar from "../Sidebar/Sidebar";
import {
  ButtonGeneric,
  ButtonsContainer,
  Container,
  ContainerInfo,
  DetailButton,
  DivBankInformation,
  DivFlexCenterIcon,
  DivFlexCenterQuotation,
  DivInformationBankDetails,
  DivQuotationSide,
  HorizontalContainer,
  HorizontalLine,
  LabelQuotationTci,
  MessageInformative,
  PWarningComment,
  SectionTitle,
  SubtitleRecaudo,
  Text,
  Title,
} from "./AdminPaymentValidationStatesSidebarStyles";
import { CompensationCodeRecaudoVal } from "./modals/CompensationCodeRecaudoVal";
import { CompensationDetailRecaudo } from "./modals/compensationDetailRecaudo";

enum substatesEnum {
  to_compensate = "to_compensate",
  pending = "pending",
  conpensated = "conpensated",
  compensating = "compensating",
}

interface Props {
  onErrorEndpoint: (error: any) => void;
  onOk: () => void;
  onOutsideClick: () => void;
  respData: any;
  setShowSidebarModal: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarInfo: any;
}
export const AdminPaymentRecaudoStatesSidebar = (props: Props) => {
  const {
    onOutsideClick,
    sidebarInfo,
    setShowSidebarModal,
    onErrorEndpoint,
    respData,
  } = props;

  const [pollPayment, setPollPayment] = useState<any>({});
  useEffect(() => {
    const found = respData.data.find(
      (invoice) => invoice.invoiceId === sidebarInfo.invoiceId
    );
    setPollPayment(found);
  }, [respData, sidebarInfo]);

  const toast = useRef(null);

  const handleDownload = (document: string) => {
    generateDownloadUrl(document).then((url) => {
      window.open(url, "_blank");
    });
  };

  const status = sidebarInfo.paymentStatus.option;
  const substatus =
    sidebarInfo.cashbackStatus.option === substatesEnum.pending
      ? substatesEnum.to_compensate
      : sidebarInfo.cashbackStatus.option === substatesEnum.compensating
      ? substatesEnum.conpensated
      : sidebarInfo.cashbackStatus.option;

  const [showModalCompensation, updateShowModalCompensation] = useState(false);

  const toogleModalCompensation = () => {
    updateShowModalCompensation(!showModalCompensation);
  };

  const [modalSuccesCode, updateModalSuccesCode] = useState(false);
  const toogleModalSuccessCode = () => {
    updateModalSuccesCode(!modalSuccesCode);
  };

  const [displayPosition, setDisplayPosition] = useState(false);

  const formatDate = (date: Date | string) => {
    const newDate = new Date(date);
    return format(newDate, "dd-MM-yyyy");
  };
  const formatTime = (time: Date | string) => {
    const timeDate = new Date(time);
    return format(timeDate, "HH:mm");
  };

  const converterNumber = (amount, digits = 2) => {
    const amountStr = Number(amount).toLocaleString("en-US", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
    return amountStr;
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />

      {showModalCompensation && (
        <CompensationCodeRecaudoVal
          toggleModal={toogleModalCompensation}
          sidebarInfo={sidebarInfo}
          onErrorData={(err) => {
            onErrorEndpoint(err);
          }}
          onSuccessData={() => {
            updateShowModalCompensation(false);
            updateModalSuccesCode(true);
          }}
        ></CompensationCodeRecaudoVal>
      )}
      {modalSuccesCode && (
        <AdminAskForAction
          toggleModal={() => {
            toogleModalSuccessCode();
            props.onOk();
          }}
          onApprove={() => {
            props.onOk();
          }}
          hideSidebar={() => props.onOk()}
          titleMessage={"Compensación exitosa"}
          bodyMessage={"La compensación con SAP a sido registrada con éxito."}
          buttonMessage={"Entendido"}
        />
      )}

      {displayPosition && (
        <CompensationDetailRecaudo
          toggleModal={() => {
            setDisplayPosition(false);
          }}
          sidebarInfo={sidebarInfo}
        />
      )}
      <Sidebar onOutsideClick={onOutsideClick}>
        <Container>
          <div>
            <Title>Recaudo Nº {sidebarInfo.invoiceNum}</Title>
            <SubtitleRecaudo textTransform="lowercase">
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "1rem" }}>Cod. Pago</div>
                <div style={{ fontWeight: 600, marginRight: "1rem" }}>
                  {sidebarInfo.bankDetail.bank_payment_code}
                </div>
                <div>| {sidebarInfo.bankDetail.bank.name}</div>
              </div>
            </SubtitleRecaudo>
            <HorizontalLine />
            <ContainerInfo>
              {sidebarInfo.warningComment && (
                <MessageInformative
                  backgroundColor={
                    status === "rejected" || status === "expired"
                      ? "rgba(255, 111, 97, 0.1)"
                      : "#FFF8DA"
                  }
                  color={
                    status === "rejected" || status === "expired"
                      ? "#FF6F61"
                      : "#000000"
                  }
                >
                  <div className="icon-message">
                    <img
                      alt="info icon"
                      src={
                        status === "rejected" || status === "expired"
                          ? icInfoRed
                          : icInfoBlack
                      }
                    />
                  </div>
                  <div className="message-info">
                    <PWarningComment>
                      {sidebarInfo.warningComment}
                    </PWarningComment>
                  </div>
                </MessageInformative>
              )}
              <HorizontalContainer>
                <div style={{ width: "45%" }}>
                  <SectionTitle>AGENTE DE ADUANA</SectionTitle>
                  <Text>{sidebarInfo.agentName}</Text>
                </div>
                <div style={{ width: "45%" }}>
                  <SectionTitle>TOTAL FACTURACIÓN</SectionTitle>
                  <Text>
                    {formatMoney(
                      sidebarInfo.salesInvoiceTotal,
                      sidebarInfo.paymentCurrency === "usd"
                    )}
                  </Text>
                </div>
              </HorizontalContainer>
              {status === "paid" && (
                <HorizontalContainer>
                  <div style={{ width: "100%" }}>
                    <SectionTitle>NRO DE SERIE / FACTURA PDF</SectionTitle>
                    {pollPayment.quotations &&
                      pollPayment.quotations.map(
                        (quotation: Quotation, i: number) => {
                          return (
                            <DivQuotationSide key={i}>
                              <DivFlexCenterQuotation>
                                <div style={{ marginRight: "1.3rem" }}>
                                  <img
                                    alt="pdf"
                                    width={"100%"}
                                    height={"100%"}
                                    src={icPDF}
                                  />
                                </div>
                                <LabelQuotationTci htmlFor="test">
                                  {quotation.tci_num}
                                </LabelQuotationTci>
                              </DivFlexCenterQuotation>
                              {quotation.quotation_doc.length > 0 && (
                                <DivFlexCenterIcon
                                  onClick={() => {
                                    handleDownload(quotation.quotation_doc);
                                  }}
                                >
                                  <img
                                    alt="down"
                                    src={icDownload}
                                    width={"100%"}
                                    height={"100%"}
                                  />
                                </DivFlexCenterIcon>
                              )}
                            </DivQuotationSide>
                          );
                        }
                      )}
                  </div>
                </HorizontalContainer>
              )}

              <div>
                <SectionTitle>DATOS DE OPERACIÓN</SectionTitle>
              </div>
              <div
                style={{
                  border: "1px solid #D9D9D9",
                  borderRadius: "8px",
                  padding: "1rem",

                  marginRight: "1.5rem",
                }}
              >
                {/* margin-right: 1.5rem; */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <SectionTitle width="19rem">BANCO</SectionTitle>
                  <DivInformationBankDetails>
                    {sidebarInfo.bankDetail.bank.name}
                  </DivInformationBankDetails>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <SectionTitle width="19rem">NÚMERO DE OPERACIÓN</SectionTitle>
                  <DivInformationBankDetails>
                    {sidebarInfo.upfrontDetail
                      ? sidebarInfo.upfrontDetail.operation_number
                      : "-"}
                  </DivInformationBankDetails>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <SectionTitle width="19rem">CUENTA TALMA</SectionTitle>
                  <DivInformationBankDetails>
                    {sidebarInfo.upfrontDetail
                      ? sidebarInfo.upfrontDetail.payment_currency === "pen"
                        ? `${sidebarInfo.upfrontDetail.talma_account} - Soles`
                        : `${sidebarInfo.upfrontDetail.talma_account} - Dólares`
                      : "-"}
                  </DivInformationBankDetails>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <SectionTitle width="19rem">MONTO PAGADO</SectionTitle>
                  <DivInformationBankDetails>
                    {sidebarInfo.upfrontDetail
                      ? sidebarInfo.upfrontDetail.payment_currency === "pen"
                        ? `S/ ${converterNumber(
                            sidebarInfo.upfrontDetail.amount
                          )}`
                        : `$ ${converterNumber(
                            sidebarInfo.upfrontDetail.amount
                          )}`
                      : "-"}
                  </DivInformationBankDetails>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <SectionTitle width="19rem">
                    FECHA Y HORA DE PAGO
                  </SectionTitle>
                  <DivInformationBankDetails>
                    {sidebarInfo.upfrontDetail
                      ? `${formatDate(
                          sidebarInfo.upfrontDetail.payment_datetime
                        )}  ${formatTime(
                          sidebarInfo.upfrontDetail.payment_datetime
                        )}`
                      : "-"}
                  </DivInformationBankDetails>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <SectionTitle width="19rem">CANAL</SectionTitle>
                  <DivInformationBankDetails>
                    {sidebarInfo.upfrontDetail
                      ? sidebarInfo.upfrontDetail.channel
                      : "-"}
                  </DivInformationBankDetails>
                </div>
              </div>
              {sidebarInfo.upfrontBankInformationComment && (
                <DivBankInformation>
                  <img src={icInfoRed} alt="" />
                  <div style={{ marginLeft: "0.5rem" }}>
                    {sidebarInfo.upfrontBankInformationComment}
                  </div>
                </DivBankInformation>
              )}
            </ContainerInfo>

            <HorizontalLine />
          </div>

          <div>
            {status !== "paid" && (
              <div>
                <ButtonGeneric
                  height="6.2rem"
                  marginBottom="2.5rem"
                  onClick={() => {
                    setShowSidebarModal(true);
                  }}
                >
                  <img src={icIconDetail} alt="Aspa" />
                  <div style={{ marginLeft: "1.25rem" }}>Ver detalle</div>
                </ButtonGeneric>
              </div>
            )}
            {status === "paid" && substatus === "to_compensate" && (
              <ButtonsContainer>
                <ApproveButton
                  style={{
                    width: "47%",
                  }}
                  onClick={() => {
                    updateShowModalCompensation(true);
                  }}
                >
                  Compensar
                </ApproveButton>
                <ButtonGeneric
                  height="6.2rem"
                  style={{
                    width: "47%",
                  }}
                  marginBottom="2.5rem"
                  onClick={() => {
                    setShowSidebarModal(true);
                  }}
                >
                  <img src={icIconDetail} alt="Aspa" />
                  <div style={{ marginLeft: "1.25rem" }}>Ver detalle</div>
                </ButtonGeneric>
              </ButtonsContainer>
            )}
            {status === "paid" && substatus === "conpensated" && (
              <ButtonsContainer>
                <DetailButton
                  width="47%"
                  onClick={() => {
                    setDisplayPosition(true);
                  }}
                >
                  <img src={icChecklistRounded} alt="Check" />
                  Detalle de compensación
                </DetailButton>
                <ButtonGeneric
                  height="6.2rem"
                  style={{
                    width: "47%",
                  }}
                  marginBottom="2.5rem"
                  onClick={() => {
                    setShowSidebarModal(true);
                  }}
                >
                  <img src={icIconDetail} alt="Aspa" />
                  <div style={{ marginLeft: "1.25rem" }}>Ver detalle</div>
                </ButtonGeneric>
              </ButtonsContainer>
            )}
          </div>
        </Container>
      </Sidebar>
    </React.Fragment>
  );
};

function generateDownloadUrl(id: string) {
  return networkBackendRequest(
    "/files/presigned-download-url/",
    HTTP_METHODS.GET,
    {
      object_name: id,
    }
  )
    .then((response) => response.json())
    .then((response) => response.url);
}
